// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1jVCP","header":"PatientBlock_header__3Ddvw","label":"PatientBlock_label__qJcSC","option":"PatientBlock_option__3hR3b"};